'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.connectedBoardChannelSelector = exports.storedBoardChannelsSelector = undefined;

var _lodash = require('lodash');

var _reselect = require('reselect');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _elementHelper = require('../../../common/elements/elementHelper');

var _remoteUsersSelector = require('./remoteUsersSelector');

var _mainSelector = require('../../workspace/main/mainSelector');

var _currentUserSelector = require('../../user/currentUserSelector');

var _elementSelector = require('../../element/elementSelector');

var _socketConstants = require('../socket/socketConstants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Util


// Selectors


// Constants


// A threshold for the number of connected boards before previously connected boards will be dropped
var CONNECTED_BOARD_THRESHOLD = 10;
var EMPTY_ARRAY = [];

/**
 * Gets the channels that are stored within the Redux store.
 */
var storedBoardChannelsSelector = exports.storedBoardChannelsSelector = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['app', 'socketConnection', 'boardChannels']);
}, function (channels) {
    return channels;
});

var getPhysicalChildIdsDeepSelector = (0, _reselect.createSelector)(_elementSelector.getElements, function (state, ownProps) {
    return ownProps.currentBoardId;
}, _elementHelper.getPhysicalChildIdsDeep);

/**
 * Viewed ancestors & viewed deep children (not descendants, just children of the current board)
 *  = active board channels we want to connect to.
 */
var activeBoardChannelSelector = (0, _milanoteReselect.createShallowSelector)(_remoteUsersSelector.getRemoteActiveCurrentlyViewedBoardIds, _mainSelector.getBreadcrumb, getPhysicalChildIdsDeepSelector, function (state, ownProps) {
    return ownProps.currentBoardId;
}, _currentUserSelector.isGuestSelector, function (currentlyViewedBoardIds, breadcrumbObj, deepChildren, currentBoardId, isGuest) {
    if (isGuest) return EMPTY_ARRAY;

    // Includes the current board
    var viewableAncestors = breadcrumbObj.path;
    var viewedAncestors = (0, _lodash.intersection)(viewableAncestors, currentlyViewedBoardIds);
    var viewedChildren = (0, _lodash.intersection)(deepChildren, currentlyViewedBoardIds);

    return [].concat(_toConsumableArray(viewedAncestors), _toConsumableArray(viewedChildren));
});

/**
 * Active board channels (Y) + previously active board channels (X)
 *    (where: X = 5 - Y  iff Y < 5)
 */
var connectedBoardChannelSelector = exports.connectedBoardChannelSelector = (0, _milanoteReselect.createShallowSelector)(activeBoardChannelSelector, storedBoardChannelsSelector, _currentUserSelector.isGuestSelector, function (activeBoardChannels, currentlyConnectedChannels, isGuest) {
    if (isGuest) return EMPTY_ARRAY;

    // Don't connect to previously connected boards if there are more than 10 active boards
    if (activeBoardChannels.length > CONNECTED_BOARD_THRESHOLD) return activeBoardChannels;

    var availablePreviouslyConnectedSpaces = CONNECTED_BOARD_THRESHOLD - activeBoardChannels.length;

    var previouslyConnectedChannels = currentlyConnectedChannels.filter(function (channel) {
        return !(0, _lodash.includes)(activeBoardChannels, channel);
    }).take(availablePreviouslyConnectedSpaces).toJS();

    return (0, _lodash.concat)(activeBoardChannels, previouslyConnectedChannels);
});

/**
 * Gets the channels based on the currently active viewed boards, the user's breadcrumb as well as a 'live activity'
 * channel which will simply be the current board ID with a '-LIVE' suffix.  The latter channel is used for sending
 * selection and deselection messages.
 */
var channelSelector = (0, _milanoteReselect.createShallowSelector)(_remoteUsersSelector.getTrackedUserIds, connectedBoardChannelSelector, function (state, ownProps) {
    return ownProps.currentBoardId;
}, _currentUserSelector.isGuestSelector, function (userIds, connectedBoardChannels, currentBoardId, isGuest) {
    if (isGuest) return EMPTY_ARRAY;

    return [].concat(_toConsumableArray(connectedBoardChannels), _toConsumableArray(userIds), [
    // TODO Potential improvement - don't join this channel when on a personal board (also no need to sync
    // TODO    selection and deselection actions in that instance).
    '' + currentBoardId + _socketConstants.LIVE_ACTIVITY_SUFFIX]);
});

exports.default = (0, _milanoteReselect.createShallowSelector)(channelSelector, connectedBoardChannelSelector, _currentUserSelector.isGuestSelector, function (channels, boardChannels, isGuest) {
    return { channels: channels, boardChannels: boardChannels, isGuest: isGuest };
});


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/socketChannelSelector.js
// module id = 465
// module chunks = 0